import React from "react";
import "./AwardPage.css";
import Navbar from "../../components/Navbar/Navbar";
export default function LakshmiIyerScholarship() {
  return (
    <>
      <section
        id="award-inner-section"
        className="award-inner-section inner-banner">
        <Navbar />
        <div className="page-title-area">
          <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-end">
            <div className="page-title-content">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Awards & Scholarships</li>
                <li>Lakshmi Iyer scholarship</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="main-heading text-center pb-1">
                <h1 className="main-title wow animate__animated animate__fadeInUp">
                  Lakshmi Iyer scholarship
                </h1>
              </div>
              <p>
                The Lakshmi Iyer scholarship has been instituted by the family
                of Late N.A. Lakshmi and Late H.P.S. Iyer for supporting
                visually impaired students pursuing higher education. Every year
                NAB Delhi management will select meritorious visually impaired
                students from weaker sections of the society and support them
                financially through Lakshmi Iyer scholarship for pursuing higher
                education.
              </p>
              <p>
                The selection of candidates will be done mostly during July to
                September every year. Meritorious visually impaired girls from
                economically weaker sections of the society will be given
                preference in selection.
              </p>
            </div>
          </div>
        </div>

        {/*  */}
        <div className="container pt-3">
          <div className="row">
            <div className="col-12">
              <div className="main-heading text-center pb-1">
                <h2 className="main-title wow animate__animated animate__fadeInUp">
                  Awardees
                </h2>
              </div>
            </div>


            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2025-2026</h3>

                <ul className="mt-3 ps-4">
                  <li>Nitesh Kumar</li>
                  <li>Gungun</li>
                  <li>Khemlata</li>


                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2024-2025</h3>

                <ul className="mt-3 ps-4">
                  <li>Sneha</li>
                  <li>Laxman Prasad Mishra</li>
                  <li>Rohit Yadav</li>
                  <li>Ritika Gupta</li>
                  <li>Shailendra</li>


                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2023 - 2024</h3>

                <ul className="mt-3 ps-4">
                  <li>Suman
                  </li>
                  <li>Anas
                  </li>
                  <li>Rohit Yadav</li>
                  <li>Ayushi Singh</li>
                  <li>Abhishek Rai</li>

                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2022 - 2023</h3>

                <ul className="mt-3 ps-4">
                  <li>Ayushi Singh
                  </li>
                  <li>Jeeramani Mahto
                  </li>
                  <li>Ritesh Kumar</li>
                  <li>Abhishek Rai</li>

                </ul>
              </div>
            </div>



          </div>
        </div>
      </section>
    </>
  );
}
